import { SkillModel } from 'components/Skills/SkillsDetail/SkillsDetail';
import { ReactComponent as githubIcon } from './github.svg';
import { ReactComponent as serverlessIcon } from './serverless-framework.svg';

export const toolsSkills: SkillModel[] = [
  { name: 'github', expertise: 'expert', icon: githubIcon },
  { name: 'serverless', expertise: 'expert', icon: serverlessIcon },
];
